/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 李勇
 * @Date: 2023-10-26 14:30:23
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-25 14:32:14
 * @FilePath: /partner.chaoyongtuan.com/src/utils/newDataMap/shopManage.js
 *
 * Copyright (c) 2023 by 央选/李勇, All Rights Reserved.
 */

// ------------------------------商品公海--------------------------
// 商品公海 搜索框 下拉框
const SEARCH_OPTIONS = [
	{ name: '商品名称', key: 'outerProductName' },
	{ name: '商品ID', key: 'productId' },
	{ name: '店铺名称', key: 'outerShopName' },
	{ name: '团长名称', key: 'institutionName' },
];

// 商品公海列表 带货数据映射关系
const SHIPMENT_DATA = new Map([
	[0, '不限'],
	[1, '灵活总佣'],
	[2, '固定佣金'],
	['shopScore', '商家体验分'],
	['commissionType', '佣金机制'],
	['talentCommission', '达人佣金率'],
	['serviceFeeRate', '服务费率'],
	['commissionRate', '灵活总佣'],
	['auditStatus', '人工审核'],
	['appType', '商家来源'],
	['1', '是'],
	['goodsSoure_1', '团长'],
	['goodsSoure_2', '商家'],
]);

// 商品公海列表 带货数据 佣金机制下拉框
const COMMISSION_MCHANISM_OPTIONS = [
	{ name: '不限', value: 0 },
	{ name: '灵活总佣', value: 1 },
	{ name: '固定佣金', value: 2 },
];

// 商品公海列表 列表筛选 升/降序
const COMMERCIAL_HIGH_SEAS_LIST = [
	{ name: '最新上架', showIcon: false, sort: false, key: 'id' },
	{ name: '30天销量', showIcon: true, sort: false, key: 'orderNum' },
	{ name: '带货达人数', showIcon: true, sort: false, key: 'kolNum' },
	{ name: '达人佣金率', showIcon: true, sort: false, key: 'talentCommission' },
	{ name: '服务费率', showIcon: true, sort: false, key: 'serviceFeeRate' },
];

// 商品公海列表 - 不限
const UNLIMITED_COMMISSION = {
	value: 0,
	name: '不限',
};

// 商品公海列表 - 灵活总佣
const AGILITY_COMMISSION = {
	value: 1,
	name: '灵活总佣',
};

// 商品公海列表 - 固定佣金
const DEAD_COMMISSION = {
	value: 2,
	name: '固定佣金',
};

// 商品公海列表 - 团长商品
const MASTER_GOODS = {
	value: 1,
	name: '团长商品',
};

// 商品公海列表 - 商家商品
const MERCHANDISE_GOODS = {
	value: 2,
	name: '商家商品',
};

// 商品公海 - 商品来源
const GOOD_SOURCE = [
	{ name: '不限', value: '' },
	{ name: '团长', value: 'goodsSoure_1' },
	{ name: '商家', value: 'goodsSoure_2' },
];

// 推广商品 审核状态
const AUDIT_STATUS_OPTIONS = [
	{ label: '待审核', value: 0 },
	{ label: '审核通过', value: 1 },
	{ label: '审核拒绝', value: 2 },
	{ label: '报名成功', value: 3 },
	{ label: '报名失败', value: 4 },
	{ label: '中止状态', value: 5 },
];

//推广状态
export const promoteText = [
	{
		label: '全部',
		value: -1,
	},
	{
		label: '推广中',
		value: 1,
	},
	{
		label: '已失效-商品下架',
		value: 2,
	},
	{
		label: '已失效-活动失效',
		value: 3,
	},
	{
		label: '暂停推广',
		value: 4,
	},
	{
		label: '待生效',
		value: 5,
	},
];

//推广状态
export const promoteTextSph = [
	{
		label: '全部',
		value: -1,
	},
	{
		label: '推广中',
		value: 1,
	},
	{
		label: '已失效-商品下架',
		value: 2,
	},
	{
		label: '已失效-合作失效',
		value: 3,
	},
	{
		label: '暂停推广',
		value: 4,
	},
	{
		label: '待生效',
		value: 5,
	},
	{
		label: '已失效-计划失败',
		value: 7,
	},
];

//商品类型
export const goodsTypeList = [
	{
		label: '全部',
		value: '0',
	},
	{
		label: '普通团长商品',
		value: '2',
	},
	{
		label: '二级团长商品',
		value: '4',
	},
	{
		label: '托管商品',
		value: '5',
	},
	{
		label: '货盘商品',
		value: '1',
	},
];

// 托管、团长商品推广状态
export const goodsPromoteStatusArr = [
	{
		label: '推广中',
		value: 1,
	},
	{
		label: '已失效-商品下架',
		value: 2,
	},
	{
		label: '已失效-合作失效',
		value: 3,
	},
	{
		label: '待审核',
		value: 5,
	},
];

// 佣金率对比
export const commissionRateList = [
	{
		label: '佣金率大于普通佣金率',
		value: '>',
	},
	{
		label: '佣金率等于普通佣金率',
		value: '=',
	},
	{
		label: '佣金率小于普通佣金率',
		value: '<',
	},
];

//抖音团长商品抖音平台报名状态
export const dytoBeClaimedStateList = [
	{
		label: '待审核',
		value: '0',
	},
	{
		label: '审核通过',
		value: '1',
	},
	{
		label: '审核拒绝',
		value: '2',
	},
	{
		label: '已失效',
		value: '5',
	},
];

//快手我的活动商品报名状态
export const ksMyActivityUpStateList = [
	{
		label: '待审核',
		value: '1',
	},
	{
		label: '审核通过',
		value: '2',
	},
	{
		label: '审核拒绝',
		value: '3',
	},
	{
		label: '已失效',
		value: '5',
	},
];

// 抖音 店铺认领状态
export const dytoShopClaimedStateList = [
	{
		label: '本人已认领店铺',
		value: 1,
	},
	{
		label: '已认领店铺',
		value: 2,
	},
	{
		label: '未认领店铺',
		value: 3,
	},
];
// 抖音平台 团长商品 流转类型
export const DYNAMIC_COLUMNS = [
	{
		label: '全部',
		value: 0,
	},
	{
		label: '新增认领商品',
		value: 1,
	},
	{
		label: '分配商品',
		value: 2,
	},
	{
		label: '取消认领商品',
		value: 3,
	},
];

export default {
	AUDIT_STATUS_OPTIONS,
	SHIPMENT_DATA,
	SEARCH_OPTIONS,
	COMMISSION_MCHANISM_OPTIONS,
	COMMERCIAL_HIGH_SEAS_LIST,
	UNLIMITED_COMMISSION,
	AGILITY_COMMISSION,
	DEAD_COMMISSION,
	MERCHANDISE_GOODS,
	MASTER_GOODS,
	GOOD_SOURCE,
	DYNAMIC_COLUMNS,
};
